<template>
  <a-button class="m-b-25 m-t-10" type="primary" v-has:wxCodeCreate="()=> {$router.push('/wxPublic/wxFeatures/add_code?type=add')}">
    <PlusOutlined />
    新建带参数二维码
  </a-button>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="二维码名称" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item label="状态" name='status'>
      <a-select v-model:value="search.status" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">已启用</a-select-option>
        <a-select-option :value="0">已失效</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="分类" name=''>
      <a-select v-model:value="search.cate_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in typeList' :key='item.id' :value="item.id">{{item.name}}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
 
    <template v-slot:action="{ record }">
      <a-dropdown>
        <a class="ant-dropdown-link"> 操作
          <DownOutlined />
        </a>
        <template v-slot:overlay>
          <a-menu>
            <a-menu-item v-if='record.status == 1'>
              <a v-has:wxCodeDown="()=>downloadImg(record)" href="javascript:;">下载二维码</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 1'>
              <a v-has:wxCodeEdit="()=> {$router.push('/wxPublic/wxFeatures/add_code?type=edit&id='+record.id)}"
                href="javascript:;">编辑</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 1'>
              <a v-has:wxCodeStatus="()=>codeStatus(record)" href="javascript:;">使失效</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 0'>
              <a v-has:wxCodeDetail="()=> {$router.push('/wxPublic/wxFeatures/add_code?type=look&id='+record.id)}"
                href="javascript:;">查看</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 0'>
              <a v-has:wxCodeDel="()=>delCode(record)" href="javascript:;">删除</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getwx_qrcode, wx_qrcode_status, wx_qrcodeDel, getwx_qrcode_cate } from "@/api/public_wx";
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 10,
    keyword:'',status:'',cate_id:''
  };
  export default {
    components: { DownOutlined, PlusOutlined },
    name: 'codeList',
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        typeList: [],
        type: 'add',
        formData: {},
        visible: false,
        listLoading: false,
        total: 1
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "分类",
          dataIndex: "cate_name",
          key: "cate_name",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
        {
          title: "剩余有效时间",
          dataIndex: "due_day",
          customRender: ({ record }) => {
            return record.due_day + '天'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //删除二维码
      const delCode = (e) => {
        $Modal.confirm({
          centered: true,
          title: '删除带参数二维码',
          content: '删除后该带参数二维码将无法恢复，您确定要删除该带参数二维码吗？', onOk: async () => {
            let res = await wx_qrcodeDel({ id: e.id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 修改二维码状态
      const codeStatus = (e) => {
        $Modal.confirm({
          title: '操作提示',
          centered: true,
          content: '确定要使该带参数二维码失效吗？', onOk: async () => {
            let res = await wx_qrcode_status({ id: e.id ,status:0}).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 获取分类
      const getType = async () => {
        let res = await getwx_qrcode_cate({ page: 1, limit: 20 }).then(res => res.data);
        if (iscode(res)) {
          state.typeList = res.data.data;
        } else {
          message.error(res.msg);
        }
      }
      const downloadImg = (e) =>{
        var a = document.createElement('a')
        a.href = e.qrcode_url
        a.download = e.name || '二维码'
        a.click();
      }
      // 获取列表
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getwx_qrcode(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
        getType();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        delCode,
        pageCurrentChange,
        pageSizeChange,
        codeStatus,
        downloadImg,
        pageSearchChange
      };
    },
  };
</script>